import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Calendar } from "lucide-react";
import PublicNav from "@/components/landing/PublicNav";
import Footer from "@/components/landing/Footer";
import AdSlot from "@/components/AdSlot";
import NewsletterForm from "@/components/NewsletterForm";
import { useSeo } from "@/hooks/useSeo";
import { ARTICLES } from "@/content/blogArticles";

export default function Blog() {
    useSeo({
        title: "Blog BOXEB2B — Prospection B2B, IA & lead gen en français",
        description: "Guides pratiques et honnêtes sur la prospection B2B en 2026 : Guyane, alternatives à UpscaleB2B, RGPD, cold emails, IA. Écrits par des opérationnels, pas par des marketeurs.",
        keywords: "blog prospection B2B, cold email, lead gen français, RGPD B2B, alternative UpscaleB2B, prospection Guyane",
        canonical: typeof window !== "undefined" ? `${window.location.origin}/blog` : "",
    });

    return (
        <div className="relative min-h-screen bg-brand-void text-white">
            <PublicNav />

            <section className="pt-32 pb-10 px-6 lg:px-10">
                <div className="mx-auto max-w-4xl">
                    <div className="text-xs uppercase tracking-[0.22em] font-bold text-brand-cyan mb-3">BOXEB2B BLOG</div>
                    <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
                        Prospection B2B, sans langue de bois
                    </h1>
                    <p className="mt-5 text-lg text-zinc-400 max-w-2xl leading-relaxed">
                        Des articles écrits pour ceux qui vendent vraiment. Pas de "growth hack",
                        pas de checklist Instagram. Juste ce qui marche en 2026, avec les vrais chiffres.
                    </p>
                </div>
            </section>

            <section className="px-6 lg:px-10 pb-24">
                <div className="mx-auto max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-5">
                    {ARTICLES.map((a, i) => (
                        <React.Fragment key={a.slug}>
                            <Link
                                to={`/blog/${a.slug}`}
                                data-testid={`blog-card-${a.slug}`}
                                className="group rounded-2xl overflow-hidden bg-brand-surface border border-white/8 hover:border-white/20 transition"
                            >
                                <div className={`h-40 bg-gradient-to-br ${a.cover_gradient} flex items-center justify-center relative overflow-hidden`}>
                                    <div className="absolute inset-0 bg-grain opacity-30" />
                                    <span className="relative text-6xl">{a.emoji}</span>
                                </div>
                                <div className="p-5">
                                    <h2 className="font-display font-bold text-lg tracking-tight text-white group-hover:text-brand-cyan transition line-clamp-2">
                                        {a.title}
                                    </h2>
                                    <p className="mt-2 text-sm text-zinc-400 line-clamp-3 leading-relaxed">
                                        {a.description}
                                    </p>
                                    <div className="mt-4 flex items-center gap-3 text-[11px] font-mono text-zinc-500">
                                        <span className="inline-flex items-center gap-1"><Calendar size={11} />{a.published_at}</span>
                                        <span className="inline-flex items-center gap-1"><Clock size={11} />{a.read_min} min</span>
                                        <span className="ml-auto inline-flex items-center gap-1 text-brand-cyan group-hover:gap-2 transition-all">
                                            Lire <ArrowRight size={12} />
                                        </span>
                                    </div>
                                </div>
                            </Link>
                            {i === 1 && (
                                <div className="md:col-span-2">
                                    <AdSlot slot="1111111111" format="auto" testId="blog-index-ad" />
                                </div>
                            )}
                        </React.Fragment>
                    ))}
                </div>

                {/* Newsletter capture on blog index too */}
                <div className="mx-auto max-w-4xl mt-10">
                    <NewsletterForm source="blog-index" />
                </div>
            </section>

            <Footer />
        </div>
    );
}
